import { TextField, type InputProps, InputAdornment, Box } from '@mui/material';
import { type FC, useEffect, useRef } from 'react';
import { search } from '@/assets';

import { autoFillColor } from '@/config/inputConfig';

interface Props extends InputProps {
  noBorder?: boolean;
  onfocus?: boolean;
}

export const SearchInput: FC<Props> = ({
  noBorder,
  onfocus,
  sx,
  placeholder,
  name,
  type,
  value,
  onChange,
}) => {
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (onfocus && inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  return (
    <>
      <input name={name} style={{ display: 'none' }} />
      <TextField
        inputRef={inputRef}
        value={value}
        onChange={onChange}
        type={type}
        fullWidth
        placeholder={placeholder}
        autoComplete={'off'}
        sx={{
          '& .MuiInputBase-root': {
            border: noBorder ? 'none' : '1px solid blue',
            borderColor: 'primary.main',
            borderRadius: '0.625rem', // 10px
            pl: '1.125rem', // 18px
            height: '3.0625rem', // 49px
            background: 'white',
          },
          fieldset: {
            border: 'none !important',
          },
          input: {
            ...autoFillColor,
          },
          ...sx,
        }}
        InputProps={{
          startAdornment: (
            <InputAdornment position='start'>
              <Box component='img' src={search} />
            </InputAdornment>
          ),
        }}
      />
    </>
  );
};
